import { Grid } from "@mui/material";
import { DateTimeInput } from "components/FormControls/DateTimeInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { useMessage } from "hooks/intl";
import { memo } from "react";

export const DateSection = memo(() => {
  const { message } = useMessage();

  return (
    <Grid
      container
      data-test-id="campaign-date"
      rowGap={12}
      columnSpacing={12}
      mt={0}
    >
      <Grid xs={6} item>
        <DateTimeInput
          data-test-id="campaign-basic-settings-start-date"
          format="yyyy-MM-dd HH:mmXXX"
          label={<RequiredFieldLabel text={message({ id: "startDate" })} />}
          name="activity.startsAt"
          width="100%"
        />
      </Grid>

      <Grid xs={6} item>
        <DateTimeInput
          data-test-id="campaign-basic-settings-end-date"
          format="yyyy-MM-dd HH:mmXXX"
          label={message({ id: "endDate" })}
          name="activity.endsAt"
          width="100%"
          withClear={true}
        />
      </Grid>
    </Grid>
  );
});
